<template>
      <div >
      <div id="overlay"  v-if="loading">
        <div class="spinner"></div>
        <br/>
          <h4>Loading...</h4>
    </div>
    <form class="form-horizontal" >
      <div class="p-grid">
        <div class="p-col">
          <Button class="p-button p-button-success addNewBtn btn-btm-0 width-auto" label="New" @click.prevent="openBasic" icon="pi pi-plus"/>
       </div>
      </div>
     <Dialog header="Item Sub-Group"  :modal="true" :visible.sync="displayBasic" :style="{width: '50vw'}"
     :closable=false :contentStyle="{'overflow': 'visible'}">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-6 p-offset-3">
              <label for="name">Name  <span style="color:red">*</span></label>
               <InputText id="name" v-model.trim="name"/>
            </div>
            <div class="p-field p-col-12 p-md-6 p-offset-3">
              <label for="itemgroup">Item Group  <span style="color:red">*</span></label>
              <Dropdown
                v-model="itemGroupId"
                :options="itemGroupLists"
                optionLabel="name"
                placeholder="Select Group"
                :filter="true"
                id="itemgroup"
                :showClear="true"
              />
            </div>
            <itemGroupDialog style="margin-top:1.3em" v-tooltip.top="'Add Item Group'"  @set_data="set_data"/>
      </div>
         <template #footer>
            <Button class="p-button-raised" :label="editing?'Update':'Add'" @click.prevent="addItemSubGroup"/>
            <Button class="p-button-raised p-button-info" v-if="!editing" label="Add & New" @click.prevent="addAndNewItemSubGroup"/>
            <Button  class="p-button-raised p-button-danger" label="Cancel" @click.prevent="cancel"/>
          </template>
          </Dialog>
        </form>
      </div>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import Dialog from 'primevue/dialog'
import itemGroupDialog from './itemGroupDialog.vue'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
export default {
  name: 'itemSubGroup',
  data() {
    return {
      name: '',
      itemGroupId: {},
      editing: false,
      displayBasic: false,
      position: 'center',
      id: '',
      loading: false
      // itemGroupLists: []
    }
  },
  computed: {
    itemGroupLists() {
      return this.$store.state.itemgroup.itemGroupLists
    }
  },
  mounted() {
    this.itemGroupList()
  },
  methods: {
    async addItemSubGroup() {
      if (this.name === '' || this.itemGroupId === '' || this.itemGroupId === null) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Item sub-group name cannot be empty!', life: 10000})
        return
      }
      let response = ''
      let itemsubgroup = {
        name: this.name,
        groupId: this.itemGroupId.id,
        id: this.id,
        isFixedAssets: false
      }
      if (!this.editing) {
        this.loading = !this.loading
        response = await this.$store.dispatch('createItemSubGroup', itemsubgroup)
        this.$emit('set_data_subGroup', response.data.data)
        this.loading = false
      } else {
        this.loading = !this.loading
        response = await this.$store.dispatch('updateItemSubGroup', itemsubgroup)
        this.loading = false
      }
      this.responseMessage(response)
      this.reset()
      this.closeBasic()
    },
    async addAndNewItemSubGroup() {
      if (this.name === '' || this.itemGroupId === '' || this.itemGroupId === null) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Item sub-group name cannot be empty!', life: 10000})
        this.validation()
        return
      }
      let response = ''
      let itemsubgroup = {
        name: this.name,
        groupId: this.itemGroupId.id,
        id: this.id,
        isFixedAssets: false
      }
      this.loading = !this.loading
      response = await this.$store.dispatch('createItemSubGroup', itemsubgroup)
      this.loading = false
      this.responseMessage(response)
    },
    async itemGroupList() {
      await this.$store.dispatch('itemGroupDropDown')
      // this.itemGroupLists = resp.data.data
    },
    set_data(data) {
      this.itemGroupId = data
    },
    editItemSubGroup(data) {
      this.editing = true
      this.name = data.name
      this.id = data.id
      let itemGroup = {
        id: data.itemGroupId.id,
        name: data.itemGroupId.name
      }
      this.itemGroupId = itemGroup
      this.openBasic()
    },
    responseMessage(response) {
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
        this.reset()
        return
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
        return
      }
    },
    cancel() {
      // this.error = false
      this.name = ''
      this.closeBasic()
      this.itemGroupId = ''
      this.editing = false
    },
    reset() {
      this.name = ''
      this.itemGroupId = ''
      this.shortName = ''
      this.editing = false
    },
    openBasic() {
      this.displayBasic = true
    },
    closeBasic() {
      this.displayBasic = false
    }
  },
  components: {
    Dropdown,
    Dialog,
    itemGroupDialog,
    Button,
    InputText
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// itemSubGroupDialog.vue?3ccc9f53